import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=67e2820f&scoped=true"
import script from "./MyCourses.vue?vue&type=script&lang=js"
export * from "./MyCourses.vue?vue&type=script&lang=js"
import style0 from "./MyCourses.vue?vue&type=style&index=0&id=67e2820f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2820f",
  null
  
)

export default component.exports